import { Mapper } from "../../../../base/utils/mapper";
import { OftalmoscopyResponseModel } from "../../../../domain/models/consult/oftalmoscopy-response.model";
import { OftalmoscopyResponseEntity } from "../entities/oftalmoscopy-response.entity";


export class OftalmoscopyImplementationRepositoryMapper extends Mapper<OftalmoscopyResponseEntity, OftalmoscopyResponseModel> {
    mapFrom(param: OftalmoscopyResponseEntity): OftalmoscopyResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: OftalmoscopyResponseModel): OftalmoscopyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}